import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { ICON_PX } from '~/theme/iconSizes';

/** Side of the tile and of its icon, in CSS pixels, per size. */
const TILE_SIZES = {
    small: { tile: 20, icon: 12 },
    medium: { tile: 28, icon: ICON_PX },
} as const;

/**
 * An icon on a tinted rounded square, the mark that opens a panel or
 * dialog header. `medium` unless given; `small` heads a dense panel with a
 * 12 px title. Two sizes only, so headers cannot drift on it.
 */
export default function IconTile({
    size = 'medium',
    children,
}: {
    size?: keyof typeof TILE_SIZES;
    children: ReactNode;
}) {
    const { tile, icon } = TILE_SIZES[size];
    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: tile,
                height: tile,
                borderRadius: 1,
                bgcolor: 'action.selected',
                color: 'primary.light',
                flexShrink: 0,
                '& svg': { width: icon, height: icon },
            }}
        >
            {children}
        </Box>
    );
}
